import { Link, Outlet } from "react-router-dom";
import { Typography, Container, TextField, Switch, InputAdornment, InputLabel, FormControl, OutlinedInput, IconButton, Box, Toolbar, AppBar, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FiChevronRight } from "react-icons/fi";
import proifleimg from '../../assets/images/proifleimg.png'
import carpark from '../../assets/images/car-parking.svg'
import tabhome from '../../assets/images/tabhome.svg'
import account from '../../assets/images/account.svg'
import support from '../../assets/images/support.svg'
import applepay from '../../assets/images/applepay.svg'
import requestcall from '../../assets/images/requestcall.svg'
import supportchat from '../../assets/images/supportchat.svg'
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Modal, Row } from "react-bootstrap";

const Supportpage = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Container>

        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <div>Account</div>
            <div className=" visablityhidden"><button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button> </div>
          </header>
          <Container className="mt-3 px-3 pagewrap"> <Link to="/requestcall">
            <Card className="support-card shadow-sm border-0">
             
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <img
                    src={requestcall}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  />
                  <span className="ms-3">Request call back</span>
                </div>
                <FiChevronRight size={20} />
              </Card.Body>
            </Card></Link>
            <Link to="/chatsupport">
            <Card className="support-card mt-3  shadow-sm border-0"> 
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <img
                    src={supportchat}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  />
                  <span className="ms-3">Support Chat</span>
                </div>
                <FiChevronRight size={20} />
              </Card.Body>
            </Card></Link>

          </Container>

          {/* Bottom Navigation */}
          <nav className="bottom-nav d-flex justify-content-around align-items-center py-2">
            <div className="nav-item "><Link to="/homepage">
              <img
                src={tabhome}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Home</span></Link>
            </div>
            <div className="nav-item " ><Link to="/pastpark">
              <img
                src={carpark}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Past Parkings</span></Link>
            </div>
            <div className="nav-item "><Link to="/account">
              <img
                src={account}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Account</span></Link>
            </div>
            <div className="nav-item active"><Link to="/supportpage">
              <img
                src={support}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Support</span></Link>
            </div>
            <div className="nav-item"><Link to="/profile">
              <img
                src={proifleimg}
                alt="Profile"
                className="rounded-circle"
              /><br></br>
              <span>Profile</span></Link>
            </div>
          </nav>


          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Sort</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="list-group">
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Newest
                  </span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Oldest
                  </span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Less Distance
                  </span>
                </label>
                <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    More Distance
                  </span>
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex p-3">
              <Button className="w-50 btn-light">
                Reset Filter
              </Button>
              <Button className="w-50 btn-brand-1 font-bold">
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>


    </>
  );
};

export default Supportpage;
